import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import CustomEventLeaderboardComponent from './js/custom-event-leaderboard.component';

ComponentsFactory.getInstance().define('custom-event-leaderboard', CustomEventLeaderboardComponent);
